import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-marquee-01';

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div data-attribute="block-marquee" data-speed="25" class="block-marquee" style="--speed: 25s;">
    <div data-attribute="list-item" class="list-item">
      <div data-attribute="item" class="item-marquee">
        <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f0bff41c86eab3acd5f7.png"
              alt=""
            />
          </div>
        </a>
      </div>
      <div data-attribute="item" class="item-marquee">
        <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f0c484b88906daaabe5c.png"
              alt=""
            />
          </div>
        </a>
      </div>
      <div data-attribute="item" class="item-marquee">
        <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f0c7ae2e2f4ae178ee8c.png"
              alt=""
            />
          </div>
        </a>
      </div>
      <div data-attribute="item" class="item-marquee">
        <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f0cb007797a985fae453.png"
              alt=""
            />
          </div>
        </a>
      </div>
      <div data-attribute="item" class="item-marquee">
        <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f0d176676ac790f239fd.png"
              alt=""
            />
          </div>
        </a>
      </div>
      <div data-attribute="item" class="item-marquee">
        <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f0d420f7997286f8450e.png"
              alt=""
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</div>

`;

export default containerFuild(html, css, {
  backgroundColor: '#A43D66',
  topPadding: false,
  bottomPadding: false,
});
